class PersonalizedProduct extends HTMLElement {
  constructor() {
    super();
    this.setupListeners();
    this.maxChars = this.getAttribute("max-chars");
    this.maxWords = this.getAttribute("max-words");
    this.input = this.querySelector('input[type="text"]');
  }
  setupListeners() {
    const input = this.querySelector('input[type="text"]');
    if (input) {
      input.addEventListener("keyup", (e) => {
        this.onInputChange(e);
      });
    }
    document.addEventListener("click", (e) => {
      const button = e.target.closest("button");
      if (button && button.matches(".personalized__symbol")) {
        this.onSymbolClick(button);
      }
    });
  }
  onSymbolClick(button) {
    const input = this.querySelector('input[type="text"]');
    const maxChars = this.maxChars;
    const val = input.value;
    const chars = val
      .split("")
      .filter((letter) => letter.charCodeAt(0) !== 65039).length;
    if (chars > maxChars - 1) {
      return;
    }
    const cursorPosition = input.selectionStart;
    const symbol = button.innerHTML;
    const inserted =
      val.substr(0, cursorPosition) + symbol + val.substr(cursorPosition);
    input.value = inserted;
  }
  onInputChange(e) {
    const input = this.querySelector('input[type="text"]');
    const maxChars = Number(this.maxChars);
    const maxWords = Number(this.maxWords);
    const val = e.target.value;
    const arr = val
      .split("")
      .filter((letter) => letter.charCodeAt(0) !== 65039);
    const hearts = val.split("").reduce((a, b) => {
      return b.charCodeAt(0) === 65039 ? a + 1 : a;
    }, 0);
    const chars = arr.length;
    const words = this.countWords(val);
    input.value = val
      .replace(new RegExp("[0-9]", "g"), "")
      .replace(new RegExp("[@#$%^&*)(+=._-]+$", "g"), "")
      .replace(";", "");
    if (maxChars && chars > maxChars) {
      input.value = val
        .split("")
        .slice(0, maxChars + hearts)
        .join("");
    }
    if (maxWords && words > maxWords) {
      input.value = val
        .split("")
        .slice(0, val.indexOf(" ", val.indexOf(" ") + maxWords - 1))
        .join("");
    }
  }
  countWords(val) {
    return val.trim().split(/\s+/).length;
  }
}

customElements.define("personalized-product", PersonalizedProduct);
